import { Badge } from '@/components/ui/badge';
import { AlertCircle, CheckCircle2 } from 'lucide-react';
import { useRecordContext } from 'ra-core';
import { CustomerInvoice, VendorBill } from '../../types';
import { useThreeWayMatch } from './useThreeWayMatch';

export const ThreeWayMatchBadge = ({ resource }: { resource: 'customer_invoices' | 'vendor_bills' }) => {
    const record = useRecordContext<CustomerInvoice | VendorBill>();
    const { loading, applicable, poMatched, grnMatched, amountMatched } = useThreeWayMatch(record);
    if (!applicable || loading) return null;

    const isSales = resource === 'customer_invoices';

    return (
        <div className="flex flex-col gap-2 mt-2">
            <span className="text-[10px] font-bold text-muted-foreground uppercase tracking-widest">{isSales ? 'Sales' : 'Procurement'} 3-Way Match</span>
            <div className="flex flex-wrap gap-2">
                <Badge variant="outline" className={`gap-1 ${poMatched ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-muted text-muted-foreground'}`}>
                    {poMatched ? <CheckCircle2 className="w-3 h-3" /> : <AlertCircle className="w-3 h-3" />}
                    {poMatched ? 'PO Matched' : 'PO Not Matched'}
                </Badge>
                <Badge variant="outline" className={`gap-1 ${grnMatched ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-amber-50 text-amber-700 border-amber-200'}`}>
                    {grnMatched ? <CheckCircle2 className="w-3 h-3" /> : <AlertCircle className="w-3 h-3" />}
                    {grnMatched ? 'GRN Matched' : 'GRN Not Matched'}
                </Badge>
                <Badge variant="outline" className={`gap-1 ${amountMatched ? 'bg-emerald-50 text-emerald-700 border-emerald-200' : 'bg-red-50 text-red-700 border-red-200'}`}>
                    {amountMatched ? <CheckCircle2 className="w-3 h-3" /> : <AlertCircle className="w-3 h-3" />}
                    {amountMatched ? 'Value Matched' : 'Value Mismatch'}
                </Badge>
            </div>
        </div>
    );
};
